import {AfterViewInit, Component, ElementRef, HostListener, NgZone, OnInit, ViewEncapsulation} from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {Router} from '@angular/router';
import {Carousel} from 'primeng/carousel';
import {AppComponent} from '../app.component';
import {environment} from '../../environments/environment';
import {SessionService} from '../Services/Session/session-service.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {FirebaseService} from '../Services/Firebase/firebase.service';

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.css', '../app.component.css', '../../assets/layout/style/layout.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProvidersComponent implements OnInit, AfterViewInit {
  providers: any;
  filteredDataSingle: any[] = [];
  items2: any[] = [];
  env = environment;
  typesProviders: any = [];
  rOptions = [];
  card: any;
  portal: string;
  setOfProviders: string = "";
  titleProvider: string;
  subTitleProvider: string;
  //https://userdetailstaging-rhslo.mongodbstitch.com/?app=RPN&setProv=502-11&card=502-661767
  srcComplete: string = "https://userdetailsprod-ycyrv.mongodbstitch.com/?";
  trustedUrl:any;

  
  constructor(public app: AppComponent, private realm: RealmService, private router: Router, private el:ElementRef,
              private zone: NgZone, private session:SessionService, private sanitizer: DomSanitizer, public fb: FirebaseService) {
    Carousel.prototype.changePageOnTouch = (e, diff) => {
      console.log(e);
      console.log(diff);
    };
  }
  ngAfterViewInit(): void {
    this.typesProviders = [
      {
        title: 'Hospitales',
        icon: 'fondo_hospitales',
        type: '2'
      },
      {
        title: 'Doctores',
        icon: 'fondo_doctores',
        type: '1'
      },
      {
        title: 'Farmacias',
        icon: 'fondo_farmacias',
        type: '4'
      },
      {
        title: 'Laboratorios',
        icon: 'fondo_laboratorios',
        type: '3'
      },
    ];
  }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getParamsToSend();
    this.fb.fetchActivate().then(() => {
      this.getRemoteConfig();
     });
    this.typesProviders = [
      {
        title: 'Hospitales',
        icon: 'fondo_hospitales',
        type: '2'
      },
      {
        title: 'Doctores',
        icon: 'fondo_doctores',
        type: '1'
      },
      {
        title: 'Farmacias',
        icon: 'fondo_farmacias',
        type: '4'
      },
      {
        title: 'Laboratorios',
        icon: 'fondo_laboratorios',
        type: '3'
      },
    ];
    this.rOptions = [
      {
        breakpoint: '1024px',
        numVisible: 4,
        numScroll: 3
      },
      {
        breakpoint: '768px',
        numVisible: 3,
        numScroll: 2
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
      }
    ];
    //this.env.isContentLoading = true;
    this.realm.setProviders$.subscribe( data => {
      this.providers = data;
      if (this.providers !== undefined) {
        this.env.isContentLoading = false;
      }
    });

    
  }
  search(event) {
    console.log('EVENTO SEARCH' , event.query);
    if (event.query.length >= 3) {
      this.realm.querySearch(event.query.toUpperCase());
    } else {
      this.filteredDataSingle = [];
    }
    this.realm.searchQuery$.subscribe(data => {
      // @ts-ignore
      this.filteredDataSingle = [];
      // @ts-ignore
      // tslint:disable-next-line:forin
      for (const dataKey in data) {
        this.filteredDataSingle.push(data[dataKey]);
      }
    });
  }

  getRemoteConfig() {
    this.titleProvider = this.fb.getStringRC('txt_title_provider');
    this.subTitleProvider = this.fb.getStringRC('txt_subtitle_provider');
  }

  async getParamsToSend() {
    this.portal = "RPN";
    this.card = await this.session.getvvalueSession('data', 'completeCard');
    let arrSetOfProviders:any = JSON.parse(await this.session.getParam('setOfProviders'));

    arrSetOfProviders.map((prov) => {
      this.setOfProviders = this.setOfProviders + prov.code + ",";
    });
    this.setOfProviders = this.setOfProviders.slice(0,-1);
    console.log("this.card "+this.card);
    console.log("this.setOfProviders "+this.setOfProviders);
    //app=RPN&setProv=502-11&card=502-661767
    this.srcComplete = this.srcComplete + "app="+this.portal+"&setProv="+this.setOfProviders+"&card="+this.card;
    console.log("srcComplete: "+ this.srcComplete);
    //this.srcComplete = "https://providers.mediprocesos.com";
    this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.srcComplete);
    
  }


  

  async navigate(event, item) {
    this.providers = JSON.parse(await this.session.getParam('providers'));
    if (this.providers !== undefined) {
      console.log('redireccion', item);
      switch (item) {
        case '1': {
          this.router.navigate(['home/providersearch', item, 'home/providers']);
          break;
        }
        case '2': {
          this.router.navigate(['home/providersearch', item, 'home/providers']);
          break;
        }
        case '3': {
          this.router.navigate(['home/providersearch', item, 'home/providers']);
          break;
        }
        case '4': {
          this.router.navigate(['home/providersearch', item, 'home/providers']);
          break;
        }
        case 'CAMPI': {
          this.router.navigate(['home/providersearch', item, 'home/providers']);
          break;
        }
        case 'alizia': {
          this.router.navigate(['home/inteli-search']);
          break;
        }
      }
    } else {
      console.log("cargando proveedores");
    }
  }
}
